import '../scss/index.scss';
import { initSignUpForms } from './components/SignUpForm.js';
import VideoModal from './components/VideoModal.js';

function init() {
    initSignUpForms();
    VideoModal.setup();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
